import { PolymerElement, html } from '@polymer/polymer/polymer-element';

class ZuiDialogFooter extends PolymerElement {
  static get properties() {
    return {};
  }

  constructor() {
    super();
  }

  ready() {
    super.ready();
  }

  static get template() {
    return html`
      <style>
        :host>div{height:60px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}
      </style>
      <div> <slot></slot> </div>
    `;
  }

}

customElements.define('zui-dialog-footer', ZuiDialogFooter);